import React from 'react';
import './Modal.css';

const DeckMenuModal = ({ visible, onAction, onClose, title = 'Deck Options' }) => {
  if (!visible) return null;

  const actions = ['View', 'Banish FD', 'Banish T.', 'Mill', 'Shuffle', 'Draw'];

  return (
    <div className="modal-backdrop">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3> {/* Use the passed title here */}
        <ul className="action-list">
          {actions.map((action, index) => (
            <li key={index} onClick={() => onAction(action)}>{action}</li>
          ))}
        </ul>
        <button onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
};

export default DeckMenuModal;
